import { makeStyles, tokens } from '@fluentui/react-components';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { Breadcrumbs } from './Breadcrumbs';
import { CommandBar } from './CommandBar';
import { ServiceRail } from './ServiceRail';

const useStyles = makeStyles({
  root: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gridTemplateRows: 'auto 1fr',
    gridTemplateAreas: `
      "commandbar commandbar"
      "rail content"
    `,
    minHeight: '100vh',
    backgroundColor: tokens.colorNeutralBackground2,
    color: tokens.colorNeutralForeground1,
  },
  commandbar: {
    gridArea: 'commandbar',
  },
  rail: {
    gridArea: 'rail',
  },
  content: {
    gridArea: 'content',
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    overflowY: 'auto',
  },
  main: {
    flex: 1,
    padding: `${tokens.spacingVerticalL} ${tokens.spacingHorizontalXXL}`,
    minWidth: 0,
  },
});

/**
 * Portal frame for the platform-admin console: a top command bar spanning the
 * full width, a dark service rail down the left, route-driven breadcrumbs, and
 * the active route's content in the main region via {@link Outlet}. Mirrors the
 * portal.azure.com chrome.
 */
export function PortalShell(): JSX.Element {
  const styles = useStyles();
  const [railCollapsed, setRailCollapsed] = useState(false);

  return (
    <div className={styles.root}>
      <div className={styles.commandbar}>
        <CommandBar
          onToggleRail={() => setRailCollapsed((collapsed) => !collapsed)}
          railCollapsed={railCollapsed}
        />
      </div>
      <div className={styles.rail}>
        <ServiceRail collapsed={railCollapsed} />
      </div>
      <div className={styles.content}>
        <Breadcrumbs />
        <main className={styles.main}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
